/*
	FRC MapLoader
	Custom Google Maps functionality for Fox Restaurant Concepts

	____________________________________________________________

	USAGE

	var myMap = new frcMap({
		autocenter: false, // When set to true, this will set the center of the map to the mean latitude/longitude of all locations
		center: [floatLat, floatLong], // The default point at which the map will center
		disableDefaultUI: true, // Disables default Google Maps UI
		offset: [0, 0], // Offsets the center of the map by the given number of degrees
		scrollwheel: false, // Disables/enables zooming the map in/out with the scroll wheel
		zoom: {
			mobile: 4, // Default zoom level for mobile devices (viewport width of up to 768px)
			desktop: 5 // Default zoom level for desktop devices
		},
		zoomControl: true // Enables/disables default Google Maps zoom control
	});

*/


(function(factory) {
	if (typeof define === 'function' && define.amd && define.amd.jQuery) {
		define(['jquery'], factory);
	}
	else if (typeof module !== 'undefined' && module.exports) {
		factory(require('jquery'));
	}
	else {
		factory(jQuery);
	}
}(function($) {
	'use strict';

	var frcMap = function(options) {

		var M = this;

		var defaults = {
			autocenter: false,
			center: [38.973731, -109.210078],
			disableDefaultUI: true,
			icons: {
				normal: {
					icon: frcContext.brand.images.mapMarkers.normal || '/static/images/icons/map-marker-open.png'
				},
				normal_selected: {
					icon: frcContext.brand.images.mapMarkers.normalSelected || '/static/images/icons/map-marker-big.png'
				}, 
				coming_soon: {
					icon: frcContext.brand.images.mapMarkers.comingSoon || '/static/images/icons/map-marker-soon.png'
				},
				coming_soon_selected: {
					icon: frcContext.brand.images.mapMarkers.comingSoonSelected || '/static/images/icons/map-marker-big-soon.png'
				}
			},
			offset: [0,0],
			scrollwheel: false,
			touched: false,
			zoom: {
				mobile: 4,
				desktop: 5
			},
			zoomControl: true
		};

		if (!(this instanceof frcMap)) {
			return new frcMap(options);
		}

		options = options || {};
		for (var def in defaults) {
			if (typeof options[def] === 'undefined') {
				options[def] = defaults[def];
			}
			else if (typeof options[def] === 'object') {
				for (var deepDef in defaults[def]) {
					if (typeof options[def][deepDef] === 'undefined') {
						options[def][deepDef] = defaults[def][deepDef];
					}
				}
			}
		}

		M.options = options;
		M.styles = [{
				featureType: "water",
				elementType: "geometry",
				stylers: [{
						color: "#e8e8e8"
					},
					{
						lightness: 17
					}
				]
			},
			{
				featureType: "landscape",
				elementType: "geometry",
				stylers: [{
						color: "#f5f5f5"
					},
					{
						lightness: 20
					}
				]
			},
			{
				featureType: "road.highway",
				elementType: "geometry.fill",
				stylers: [{
						color: "#cfcfcf"
					},
					{
						lightness: 20
					}
				]
			},
			{
				featureType: "road.highway",
				elementType: "geometry.stroke",
				stylers: [{
						color: "#e8e8e8"
					},
					{
						lightness: 29
					},
					{
						weight: .2
					}
				]
			},
			{
				featureType: "road.arterial",
				elementType: "geometry",
				stylers: [{
						color: "#ffffff"
					},
					{
						lightness: 18
					}
				]
			},
			{
				featureType: "road.local",
				elementType: "geometry",
				stylers: [{
						color: "#ffffff"
					},
					{
						lightness: 16
					}
				]
			},
			{
				featureType: "landscape.man_made",
				elementType: "geometry.fill",
				stylers: [{
						color: "#e9e9e9"
					},
					{
						lightness: 5
					}
				]
			},
			{
				featureType: "landscape.man_made",
				elementType: "geometry.stroke",
				stylers: [{
						color: "#f5f5f5"
					},
					{
						lightness: 5
					},
					{
						weight: 10
					}
				]
			},
			{
				featureType: "poi",
				elementType: "geometry",
				stylers: [{
						color: "#f5f5f5"
					},
					{
						lightness: 21
					}
				]
			},
			{
				featureType: "poi.park",
				elementType: "geometry",
				stylers: [{
						color: "#efefef"
					},
					{
						lightness: 21
					}
				]
			},
			{
				elementType: "labels.text.stroke",
				stylers: [{
						visibility: "on"
					},
					{
						color: "#ffffff"
					},
					{
						lightness: 16
					}
				]
			},
			{
				elementType: "labels.text.fill",
				stylers: [
					{
						color: "#464646"
					},
					{
						lightness: 20
					}
				]
			},
			{
				elementType: "labels.icon",
				stylers: [{
					visibility: "off"
				}]
			},
			{
				featureType: "transit",
				elementType: "geometry",
				stylers: [{
						color: "#f2f2f2"
					},
					{
						lightness: 19
					}
				]
			},
			{
				featureType: "administrative",
				elementType: "geometry.fill",
				stylers: [{
						color: "#fefefe"
					},
					{
						lightness: 20
					}
				]
			},
			{
				featureType: "administrative",
				elementType: "geometry.stroke",
				stylers: [{
						color: "#fefefe"
					},
					{
						lightness: 17
					},
					{
						weight: 1.2
					}
				]
			}
		];

		M.checkMobile = function() {
			if ($('.mobile-nav-switch').css('display') == 'none') {
				return false;
			}
			else {
				return true;
			}
		};

		M.getPositionObj = function(lat, lng) {
			var position = new google.maps.LatLng(lat, lng);
			return position;
		};

		M.getMapOptions = function() {
			var mapOptions = {};

			mapOptions.center = M.getPositionObj((M.options.center[0] + M.options.offset[0]), (M.options.center[1] + M.options.offset[1]));
			mapOptions.disableDefaultUI = M.options.disableDefaultUI;
			mapOptions.scrollwheel = M.options.scrollwheel;
			mapOptions.styles = M.options.styles || M.styles;
			mapOptions.zoom = M.options.isMobile ? M.options.zoom.mobile : M.options.zoom.desktop;
			mapOptions.zoomControl = M.options.zoomControl;

			return mapOptions;
		};

		M.setMarker = function(objListing, arrPosition, strIconType, objAnimation) {
			var marker = new google.maps.Marker({
				position: M.getPositionObj(arrPosition[0], arrPosition[1]),
				icon: M.options.icons[strIconType].icon,
				animation: objAnimation,
				map: M.mapObj
			});

			return marker;
		};

		M.populateMap = function() {
			if(!frc.page.data.mapTilesLoaded) {
				frc.page.data.mapTilesLoaded = true;

				window.setTimeout(function() {
					M.mapMarkers = [];
					M.options.listings.forEach(function(listing) {
						var iconType = 'normal';
						if (listing.location.statusIndicationMessage == 'coming_soon') {
							iconType = 'coming_soon';
						}

						if (M.options.listings.length === 1) {
							if (iconType == 'normal') {
								iconType = 'normal_selected';
							}
							else {
								iconType = 'coming_soon_selected';
							}
						}

						var newMarker = M.setMarker(listing, listing.location.coordinates, iconType, google.maps.Animation.DROP);
						newMarker.addListener('click', function() {
							$(window).trigger('markerclicked', {
								'marker': newMarker,
								'listing': listing
							});
						});
						M.mapMarkers.push({
							'originalIcon': M.options.icons[iconType].icon,
							'marker': newMarker,
							'listing': listing
						});
						frc.page.data.mapMarkers = M.mapMarkers;
					});
					$(window).trigger("maptilesloaded");
				}, 0);
			}
		};

		M.getMeanCoords = function(objListing) {
			var lesserLong = -1000,
				greaterLong = 0,
				lesserLat = 1000,
				greaterLat = 0;

			for (var i = 0; i < objListing.length; i++) {
				var thisLat = objListing[i].location.coordinates[0],
					thisLong = objListing[i].location.coordinates[1];

				if (lesserLong < thisLong) {
					lesserLong = thisLong;
				}
				if (greaterLong > thisLong) {
					greaterLong = thisLong;
				}

				if (lesserLat > thisLat) {
					lesserLat = thisLat;
				}
				if (greaterLat < thisLat) {
					greaterLat = thisLat;
				}
			}

			var meanCoords = [parseFloat((lesserLat + greaterLat) / 2).toFixed(9), parseFloat((lesserLong + greaterLong) / 2).toFixed(9)];

			return meanCoords;
		};

		M.setCenter = function(fltLat, fltLong) {
			if (!M.options.isMobile) {
				M.options.center = [fltLat, fltLong];
				M.mapObj.panTo(M.getPositionObj(fltLat, fltLong));
			}
		};

		M.setZoom = function(intZoom) {
			M.mapObj.setZoom(intZoom);
		};

		M.setDefaultPositioning = function() {
			if (M.options.autocenter && !M.options.touched) {
				M.options.center = M.getMeanCoords(M.options.listings);

				if (!M.options.isMobile && frc.data.user.geolocation) {
					M.options.center = frc.data.user.geolocation.coordinates;
				}
			}

			var mapOptions = M.getMapOptions();
			return mapOptions;
		};

		M.update = function() {
			M.options.isMobile = M.checkMobile();
			var defaults = M.setDefaultPositioning();

			window.setTimeout(function() {
				M.mapObj.panTo(defaults.center);
				M.mapObj.setZoom(defaults.zoom);
			}, 10);
		};

		M.init = function() {
			M.options.isMobile = M.checkMobile();

			var mapOptions = M.setDefaultPositioning();

			M.mapObj = new google.maps.Map(document.getElementById(M.options.container), mapOptions);

			google.maps.event.addListener(M.mapObj, "tilesloaded", function() {
				M.populateMap();
			});

			google.maps.event.addListener(M.mapObj, "dragend", function() {
				M.options.touched = true;
				var newCenter = M.mapObj.getCenter();
				M.options.center = [newCenter.lat(), newCenter.lng()];
			});

			google.maps.event.addListener(M.mapObj, "zoom_changed", function() {
				M.options.touched = true;
				if (M.options.isMobile) {
					M.options.zoom.mobile = M.mapObj.getZoom();
					M.options.zoom.desktop = M.options.zoom.mobile + 1;
				}
				else {
					M.options.zoom.desktop = M.mapObj.getZoom();
					M.options.zoom.mobile = M.options.zoom.desktop - 1;
				}
			});

			$(window).resize(function() {
				M.update();
			});

			return M;
		};

		M.init();
	};

	window.frcMap = frcMap;

}));